import { render, staticRenderFns } from "./FloatContact.vue?vue&type=template&id=b4f2b9cc&scoped=true"
import script from "./FloatContact.vue?vue&type=script&lang=js"
export * from "./FloatContact.vue?vue&type=script&lang=js"
import style0 from "./FloatContact.vue?vue&type=style&index=0&id=b4f2b9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f2b9cc",
  null
  
)

export default component.exports